"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidImageUrl = void 0;
var isValidImageUrl = function (url) {
  return !!(url === null || url === void 0 ? void 0 : url.match(/\.(jpeg|jpg|gif|png|bmp|webp)$/i));
};
exports.isValidImageUrl = isValidImageUrl;